import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
    getName
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
import { ApexOptions } from "apexcharts";
import { prepareGraphData, barChartOptions } from "../../../components/src/utils";
// Customizable Area Start
// Customizable Area End

export const webConfigJSON = require("./config.js");

export interface Props {
    navigation: any;
    // Customizable Area Start
    checked: boolean
    // Customizable Area End
}
interface S {
    // Customizable Area Start
    chartOptions: ApexOptions;
    series: ApexAxisChartSeries;
    loading: boolean;
    current_price_and_share: number;
    share_purchased: number;
    cost_basis: number;
    total_share_value: number;
    // Customizable Area End
}
interface SS { }

export default class OwnershipScreenController extends BlockComponent<Props, S, SS> {
    // Customizable Area Start
    ownershipsApiCallId: string = "";

    constructor(props: Props) {
        super(props);
        this.receive = this.receive.bind(this);

        this.subScribedMessages = [
            getName(MessageEnum.RestAPIResponceMessage),
        ];

        this.state = {
            chartOptions: { ...barChartOptions },
            series: [{ data: [], name: 'Revenue' }],
            loading: false,
            current_price_and_share: 0,
            share_purchased: 0,
            cost_basis: 0,
            total_share_value: 0,
        };

        runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
    }

    async receive(from: string, message: Message) {
        if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
            const apiRequestCallId = message.getData(
                getName(MessageEnum.RestAPIResponceDataMessage)
            );

            let responseJSON = message.getData(
                getName(MessageEnum.RestAPIResponceSuccessMessage)
            );

            if (responseJSON && !responseJSON.errors) {
                if (apiRequestCallId === this.ownershipsApiCallId) {
                    this.responseHandler(responseJSON);
                }
            }
        }
    }

    responseHandler = (responseJSON: any) => {
        const list = responseJSON.revenue ?? [];
        const graphData = prepareGraphData(list, this.props.checked);

        this.setState({
            loading: false,
            series: graphData.series,
            chartOptions:graphData.options,
            current_price_and_share: responseJSON.current_price_and_share,
            share_purchased: responseJSON.share_purchased,
            cost_basis: responseJSON.cost_basis,
            total_share_value: responseJSON.total_share_value,
        });
    }

    navigateToEarnigs = () => {
        this.props.navigation.navigate("Earnings");
    }

    async componentDidMount() {
        super.componentDidMount();
        this.fetchOwnerships();
    }

    fetchOwnerships = () => {
        this.setState({ loading: true })
        const token = localStorage.getItem("authToken");
        const headers = {
            'Content-Type': webConfigJSON.dashboarContentType,
            token,
        };

        const requestMessage = new Message(
            getName(MessageEnum.RestAPIRequestMessage)
        );

        this.ownershipsApiCallId = requestMessage.messageId;

        requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), webConfigJSON.ownershipEndPoint);
        requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), webConfigJSON.dashboarApiMethodType);
        requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), headers);

        runEngine.sendMessage(requestMessage.id, requestMessage)
    }
    // Customizable Area End
}
